module.exports = __webpack_public_path__ + "media/images/img_new_main_member_register_step1-e113e931c97a4ea450a12addc52512d1.png";